import { jsx as _jsx } from "react/jsx-runtime";
import { LINK_FILTER } from '@as-react/common-types';
import { FiltersSelectList } from './FiltersSelectList';
export const FilterItemContentLinkFilter = ({ desktop, filter, onFilterItemChange, toggleFilterOptions, }) => (_jsx(FiltersSelectList, { toggleFilterOptions: toggleFilterOptions, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: LINK_FILTER }));
